import { FunctionComponent } from 'react';
import Card from '../../../../../../Card';
import styles from './styles.module.scss';

type EmailConfirmationCardProps = {
    requestId?: string;
};

export const EmailConfirmationCard: FunctionComponent<EmailConfirmationCardProps> = ({
    requestId,
}) => {
    if (!requestId) {
        return null;
    }

    return (
        <Card>
            <h3 className={styles.heading}>Check your inbox for a confirmation email</h3>
            <span className={styles.applicationReference}>Application reference: {requestId}</span>
        </Card>
    );
};
